/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React, { useEffect } from 'react';

import HeaderText, { HeaderTextVariants } from 'components/HeaderText';

import LoadingIndicator from 'components/LoadingIndicator';

import useApi from 'api/hooks/useApi';
import { createPushToCardUrl, refreshPushToCardAccounts } from 'api/payments/pushToCard';

function AddCardFrame({ url, onComplete }) {

  useEffect(() => {
    const handleMessage = (event) => {
      if (event?.data?.action === 'complete') {
        onComplete?.();
      }
    };

    // Attach listener
    window.addEventListener('message', handleMessage);

    // Cleanup on unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  if (!url) return null;

  return (
    <div>
      <iframe
        src={url}
        style={{
          height: '700px',
          width: '100%',
          border: '0px none'
        }} />
    </div>
  );
}

function modifyUrl(url) {
  if (!url) return url;

  // the redirect url is really just to get to our callback page
  // but the configured domain via dash may not align with the actual domain we are in now
  // so rewrite the url dynamically
  const u = new URL(url);
  u.searchParams.set('return_url', `${window.location.origin}/callback`);
  return u.toString();
}

function AddCard({
  addressBookId,
  onComplete
}) {
  const urlApi = useApi(createPushToCardUrl, 'CreatePushToCardUrl');
  const refreshApi = useApi(refreshPushToCardAccounts, 'RefreshPushToCard', {
    onComplete
  });

  useEffect(() => {
    if (addressBookId) {
      urlApi.call({
        addressBookId
      });
    }
  }, [addressBookId]);

  const url = modifyUrl(urlApi.getResponse()?.url);

  const complete = () => {
    refreshApi.call({
      addressBookId
    });
  };

  let content = null;
  if (urlApi.isLoading()) {
    content = (
      <LoadingIndicator>
        Pulling up account information...
      </LoadingIndicator>
    );
  } else if (refreshApi.isLoading()) {
    content = (
      <LoadingIndicator>
        Adding your card account...
      </LoadingIndicator>
    );
  } else if (url) {
    content = (
      <AddCardFrame url={url}
        onComplete={() => complete()} />
    );
  } else {
    content = (
      <div className="vp-error">
        Unable to load account information.
      </div>
    );
  }

  return (
    <div>
      <HeaderText variant={HeaderTextVariants.Small} style={{ paddingBottom: '20px' }}>
        Complete the form below to add a card account for receiving payments.
      </HeaderText>
      {content}
    </div>
  );
}

export default AddCard;

